import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const SEO = ({ description, title, image }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            author
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const siteName = site.siteMetadata.title;
  
  // Ensure image path always has logo.png as fallback
  const metaImage = image 
    ? (image.startsWith('http') ? image : `${site.siteMetadata.siteUrl}${image}`)
    : `${site.siteMetadata.siteUrl}/logo.png`;

  return (
    <Helmet
      htmlAttributes={{ lang: 'id' }}
      title={title}
      titleTemplate={`%s | ${siteName}`}
      link={[
        { rel: 'icon', type: 'image/png', href: '/logo.png' },
        { rel: 'apple-touch-icon', href: '/logo.png' },
      ]}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:site_name',
          content: siteName,
        },
        {
          property: 'og:url',
          content: site.siteMetadata.siteUrl,
        },
        {
          property: 'og:image',
          content: metaImage,
        },
        {
          property: 'og:image:width',
          content: '1024',
        },
        {
          property: 'og:image:height',
          content: '1024',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          name: 'twitter:image',
          content: metaImage,
        },
        // WhatsApp specific
        {
          property: 'al:ios:url',
          content: site.siteMetadata.siteUrl,
        },
        {
          property: 'al:android:url',
          content: site.siteMetadata.siteUrl,
        },
        {
          property: 'al:web:url',
          content: site.siteMetadata.siteUrl,
        },
      ].filter(Boolean)}
    />
  );
};

export default SEO;
